module.exports = __webpack_public_path__ + "static/img/safeBook.5c606dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/safeBook.png
// module id = g/tY
// module chunks = 1